export default function CheckboxList({ options, selectedValues, setSelectedValues }) {
  const handleToggle = (value) => {
    setSelectedValues({
      ...selectedValues,
      [value]: !selectedValues[value],
    });
  };

  return (
    <div className="flex flex-col w-full mb-4">
      <div className="flex flex-col gap-2">
        {options.map((opt) => (
          <label key={opt.value} className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={!!selectedValues[opt.value]}
              onChange={() => handleToggle(opt.value)}
              className="form-checkbox h-5 w-5 text-blue-500"
            />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
